import { Link, Navigate, useParams } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/Brand";
import { SERVICES } from "@/lib/siteContent";

export default function ServicePage() {
  const { slug } = useParams();
  const s = SERVICES.find((x) => x.slug === slug);
  if (!s) return <Navigate to="/" replace />;
  const others = SERVICES.filter((x) => x.slug !== slug);

  return (
    <div className="flex min-h-screen flex-col bg-slate-50">
      <SiteHeader />
      <section className="border-b border-slate-200 bg-white">
        <div className="mx-auto grid max-w-6xl gap-10 px-6 py-16 lg:grid-cols-2 lg:items-center">
          <div className="fade-up">
            <p className="font-mono text-xs uppercase tracking-wider text-blue-600">{s.eyebrow}</p>
            <h1 data-testid="service-title" className="mt-3 font-heading text-4xl font-bold leading-tight tracking-tight text-slate-900 sm:text-5xl">{s.title}</h1>
            <p className="mt-5 max-w-lg leading-relaxed text-slate-600">{s.intro}</p>
            <Link to={s.cta.to} data-testid="service-cta-button" className="mt-8 inline-flex items-center gap-2 rounded-lg bg-slate-900 px-6 py-3.5 font-medium text-white transition-colors hover:bg-blue-600">
              {s.cta.label} <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
          <img src={s.image} alt={s.title} className="fade-up h-80 w-full rounded-2xl object-cover" style={{ animationDelay: "120ms" }} />
        </div>
      </section>
      <main className="mx-auto w-full max-w-6xl flex-1 px-6 py-16">
        <h2 className="font-heading text-2xl font-bold tracking-tight text-slate-900">Cosa comprende</h2>
        <div className="mt-8 grid gap-px overflow-hidden rounded-2xl border border-slate-200 bg-slate-200 md:grid-cols-2">
          {s.points.map(([t, d], i) => (
            <div key={t} data-testid={`service-point-${i}`} className="bg-white p-6">
              <span className="grid h-7 w-7 place-items-center rounded-full bg-emerald-50 text-emerald-600"><Check className="h-4 w-4" /></span>
              <h3 className="mt-3 font-heading font-semibold text-slate-900">{t}</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-slate-600">{d}</p>
            </div>
          ))}
          <div className="flex flex-col justify-center bg-slate-900 p-6">
            <p className="font-heading font-semibold text-white">Vuoi saperne di più?</p>
            <Link to={`/contatti?servizio=${s.slug}`} data-testid="service-contact-link" className="mt-2 inline-flex items-center gap-1 text-sm text-blue-300 hover:text-white">Scrivici per una consulenza <ArrowRight className="h-4 w-4" /></Link>
          </div>
        </div>
        <div className="mt-16">
          <p className="text-[11px] font-semibold uppercase tracking-wider text-slate-500">Altri servizi</p>
          <div className="mt-3 grid gap-4 sm:grid-cols-2">
            {others.map((o) => (
              <Link key={o.slug} to={`/servizi/${o.slug}`} data-testid={`service-other-${o.slug}`} className="group flex items-center justify-between rounded-xl border border-slate-200 bg-white px-5 py-4 transition-colors hover:border-slate-900">
                <span className="font-medium text-slate-900">{o.title}</span><ArrowRight className="h-4 w-4 text-slate-400 group-hover:text-slate-900" />
              </Link>
            ))}
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
